import { useUser } from "@/contexts/user-provider";

import { useModule } from "@/hooks/use-module";

import { PERMISSIONS, hasAnyPermission } from "@/lib/permissions";

/** Whether the current user can open an Ask Decoda chat. */
export function useCanUseAskDecoda(): boolean {
  const { currentUser } = useUser();
  const hasModule = useModule("ASK_DECODA");
  return (
    hasModule &&
    hasAnyPermission(currentUser, [
      PERMISSIONS.AI_USE,
      PERMISSIONS.AI_AGENT_USE,
      PERMISSIONS.AI_ANALYTICS_USE,
    ])
  );
}
